/*
 * Copyright (c) New Cloud Technologies, Ltd., 2013-2024
 *
 * You can not use the contents of the file in any way without New Cloud Technologies, Ltd. written permission.
 * To obtain such a permit, you should contact New Cloud Technologies, Ltd. at https://myoffice.ru/contacts/
 *
 */

export enum DocumentTypes {
    document = 'document',
    spreadsheet = 'spreadsheet',
    presentation = 'presentation',
}

export enum DocumentFormats {
    XO = 'XO',
    SERIALIZED = 'Serialized',
    PLAIN_TEXT = 'PlainText',
    DSV = 'DSV',
    OXML = 'OXML',
    ODF = 'ODF',
    PDF = 'PDF',
    PDFA = 'PDFA',
    // text
    DOCX = 'DOCX',
    ODT = 'ODT',
    XODT = 'XODT',
    DOC = 'DOC',
    DOT = 'DOT',
    DOTX = 'DOTX',
    DOCM = 'DOCM',
    RTF = 'RTF',
    XOTT = 'XOTT',
    OTT = 'OTT',
    TXT = 'TXT',
    DOTM = 'DOTM',
    // spreadsheet
    XLS = 'XLS',
    XLT = 'XLT',
    XLTX = 'XLTX',
    XLSM = 'XLSM',
    XLTM = 'XLTM',
    CSV = 'CSV',
    XOTS = 'XOTS',
    OTS = 'OTS',
    TSV = 'TSV',
    // presentation
    PPTX = 'PPTX',
    ODP = 'ODP',
    XODP = 'XODP',
    PPT = 'PPT',
    POT = 'POT',
    POTX = 'POTX',
    PPS = 'PPS',
    PPSX = 'PPSX',
    PPSM = 'PPSM',
    PPTM = 'PPTM',
    XOTP = 'XOTP',
    OTP = 'OTP',
}
